import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { validateRuleData, loading } from '@/decorators';
import { loadQiyuScript } from '@/utils/qiyuService';
var User = namespace('user');
var Common = namespace('common');
var TabPage = namespace('tabpage');

var LoginPage = function (_super) {
  __extends(LoginPage, _super);

  function LoginPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.title = _this.t('更懂电商的海外仓专家');
    _this.validateCodeImageUrl = '';
    _this.validateCodeImageLoading = true;
    _this.loginLoading = false;
    _this.showCaptcha = false;
    _this.formData = {
      account: '',
      password: '',
      image_validation_code: ''
    };
    _this.formDataRule = {};
    return _this;
  }

  LoginPage.prototype.validateFormDataRule = function (validateData) {
    this.formDataRule = validateData;
  };

  LoginPage.prototype.handleEnter = function () {
    this.handleLogin();
  };

  LoginPage.prototype.getNewValidateCodeImageUrl = function () {
    return this.$config.validateCodeImageUrl + "?t=" + new Date().getTime();
  };

  LoginPage.prototype.updatedValidateCodeImageUrl = function () {
    var _this = this;

    this.validateCodeImageLoading = true;
    this.validateCodeImageUrl = this.getNewValidateCodeImageUrl();
    var image = new Image();
    image.src = this.validateCodeImageUrl;

    image.onload = function () {
      _this.validateCodeImageLoading = false;
    };
  };

  LoginPage.prototype.login = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res, res_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, 3, 4]);

            return [4, this.$api.user.login(params)];

          case 1:
            res = _a.sent();
            return [2, res];

          case 2:
            res_1 = _a.sent();

            if (res_1.data && res_1.data.show_captcha) {
              this.showCaptcha = true;
            }

            if (res_1 instanceof Object && res_1.status === 403) {
              this.$router.push({
                name: '403',
                query: {
                  code: res_1.data.code
                }
              });
            }

            return [2, Promise.reject(res_1)];

          case 3:
            this.updatedValidateCodeImageUrl();
            return [7];

          case 4:
            return [2];
        }
      });
    });
  };

  LoginPage.prototype.updateApiPermissionList = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.updateApiPermissionList()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  LoginPage.prototype.handleSwitchImageValidateCode = function () {
    this.updatedValidateCodeImageUrl();
  };

  LoginPage.prototype.handleLogin = function () {
    var _this = this;

    var formDataRef = this.$refs.formDataRef;
    formDataRef.validate(function (valid) {
      return __awaiter(_this, void 0, void 0, function () {
        var params, res, token, e_1;

        var _this = this;

        var _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (!valid) return [3, 6];
              this.clearUserData();
              params = this.$util.deepCopy(this.formData);
              params.password = this.$util.encryptionPassword(params.password);
              return [4, this.login(params)];

            case 1:
              res = _b.sent();
              token = ((_a = res.data) === null || _a === void 0 ? void 0 : _a.token) || '';
              token && localStorage.setItem('user_token', token);

              if (res.code !== 0) {
                return [2];
              }

              _b.label = 2;

            case 2:
              _b.trys.push([2, 4,, 5]);

              return [4, this.updateApiPermissionList()];

            case 3:
              _b.sent();

              return [3, 5];

            case 4:
              e_1 = _b.sent();
              console.error(e_1);
              return [3, 5];

            case 5:
              this.initPage();
              this.initUserMsg(function () {
                _this.setSurveyShow(true);

                _this.setEditContackShow(true);

                _this.redirect();
              });
              _b.label = 6;

            case 6:
              return [2];
          }
        });
      });
    });
  };

  LoginPage.prototype.redirect = function () {
    var _a;

    var redirectUrl = this.$route.query.redirect_url;

    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    var href = this.defaultUrl;
    var lastRouteString = localStorage.getItem('lastRoute');

    if (lastRouteString && this.userInfo.customer_status !== this.$enum.mine.UserStatus.FROZEN) {
      var lastRoute = JSON.parse(lastRouteString);
      var isLate = new Date().getTime() - lastRoute.timestamp > this.$config.lastRouteExpiresMin * 1000 * 60;
      var isSameUser = this.userInfo.user_code === lastRoute.user_code || lastRoute.loginStatus === false;
      var hasRoute = lastRoute.fullPath && !!lastRoute.fullPath.slice(1);
      var hasPermission = lastRoute.meta.permissionControl === false || this.$util.hasPermission(this.routerPermission, lastRoute.path);
      var noLogin = (_a = lastRoute === null || lastRoute === void 0 ? void 0 : lastRoute.meta) === null || _a === void 0 ? void 0 : _a.noLogin;

      if (!isLate && hasRoute && isSameUser && hasPermission && !noLogin) {
        href = lastRoute.fullPath;
      }

      localStorage.removeItem('lastRoute');
    }

    var signAbandonGoodsAgreement = this.$route.query.sign_abandon_goods_agreement;
    window.location.href = !!signAbandonGoodsAgreement ? href.indexOf('?') > -1 ? href.indexOf('sign_abandon_goods_agreement') > -1 ? href : href + '&sign_abandon_goods_agreement=1' : '?sign_abandon_goods_agreement=1' : href;
  };

  LoginPage.prototype.created = function () {
    this.$store.dispatch('setTitle', this.title);
    this.updatedValidateCodeImageUrl();
    this.queryBackgroundUrl();
    loadQiyuScript()["catch"](function () {
      return undefined;
    });
  };

  __decorate([Common.State('backgroundUrl')], LoginPage.prototype, "backgroundUrl", void 0);

  __decorate([Common.Action('queryBackgroundUrl')], LoginPage.prototype, "queryBackgroundUrl", void 0);

  __decorate([User.State('routerPermission')], LoginPage.prototype, "routerPermission", void 0);

  __decorate([User.State('userInfo')], LoginPage.prototype, "userInfo", void 0);

  __decorate([User.State('defaultUrl')], LoginPage.prototype, "defaultUrl", void 0);

  __decorate([User.State('hasAllPermission')], LoginPage.prototype, "hasAllPermission", void 0);

  __decorate([User.Action('initUserMsg')], LoginPage.prototype, "initUserMsg", void 0);

  __decorate([User.Mutation('SET_SURVEY_SHOW')], LoginPage.prototype, "setSurveyShow", void 0);

  __decorate([User.Mutation('SET_EDIT_CONTACT_SHOW')], LoginPage.prototype, "setEditContackShow", void 0);

  __decorate([TabPage.Action('init')], LoginPage.prototype, "initPage", void 0);

  __decorate([User.Action('clearUserData')], LoginPage.prototype, "clearUserData", void 0);

  __decorate([validateRuleData('/api/v1/user_public/login')], LoginPage.prototype, "validateFormDataRule", null);

  __decorate([loading('loginLoading')], LoginPage.prototype, "login", null);

  LoginPage = __decorate([Component], LoginPage);
  return LoginPage;
}(Vue);

export default LoginPage;